import { render, staticRenderFns } from "./GetValueSlot.vue?vue&type=template&id=3bbb21b2&"
import script from "./GetValueSlot.vue?vue&type=script&lang=js&"
export * from "./GetValueSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports